import React, { useEffect, useState } from 'react';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import logoOCBH from './ocbh.svg';
import logoSA from './sa.svg';
import NextOCBH from './NextOCBH';
import NextSA from './Trip';
import { NextTrip, NextTripSource } from './types/NextTrip';
import Trip from './Trip';
import { wallboardService } from './services/WallboardService';
import { DateTime } from 'luxon';

function App() {
  const [slide, setSlide] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [progress, setProgress] = useState(0);
  //const [nextTrips, setNextTrips] = useState<NextTrip[]>();
  const [sources, setSources] = useState<NextTripSource[]>(
    [
      { brand: "OCBH", showName: true, title: "NEXT DEPARTURE", expires: 0, url: "https://app.ocbayhopper.com/v2/wallboard/next-west-oc" },
      { brand: "SA", showName: true, title: "NEXT DEPARTURE", expires: 0, url: "https://book.sailalyosha.com/api/wallboard/next-west-oc" },
      { brand: "OCBH", showName: false, title: "SUNSET CRUISE", expires: 0, url: "https://app.ocbayhopper.com/v2/wallboard/next-west-oc?experienceId=19" },
      { brand: "SA", showName: false, title: "SUNSET CRUISE", expires: 0, url: "https://book.sailalyosha.com/api/wallboard/next-west-oc?sunset=true" },
    ]
  );
  //const [nextTrips, setNextTrips] = useState<NextTrip[]>([]);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const dwell = params.has("dwell")
    ? parseInt(params.get("dwell") as string)
    : 14000;
  
  // Next OCBH Trip
  // const fetchNextTrip = (brand: string, name: string) => {
  //   wallboardService
  //     .nextTrip("https://localhost:44375/v2/wallboard/next-west-oc")
  //     .then(trip => {

  //     });
  // };
  // useEffect(
  //   () => {
  //     // TODO Fetch next trips
  //     let timeout :NodeJS.Timeout;
  //     //  = setTimeout(() => {

  //     // });

  //     return () => clearTimeout(timeout);
  //   },
  //   []
  // )

  useEffect(
    () => {
      let interval :NodeJS.Timer | undefined;
      if (isActive) {
        interval = setInterval(() => {
          // console.log("sources", sources);
          setSlide(slide => slide + 1);
          setProgress(0);
          sources.forEach((source) => {
              // console.log("processing  ", source);
            // handle any expiration
            if (source.expires > new Date().getTime()) {
              // console.log("source cached ", source);
              return; // has not expired
            }
            // console.log("fetching ", source);
            source.expires = new Date().getTime() + 30000;
            wallboardService.nextTrip(source.url)
            .then((nextTrip) => {
              console.log("nextTrip", nextTrip);

              source.expires = new Date(nextTrip.startTime).getTime();
              // console.log("nextTrips", nextTrips);
              // setNextTrips(val => [...val?.filter(t => t !== source.trip) || [], nextTrip]);
              nextTrip.startDateTime = DateTime.fromISO(nextTrip.startTime);
              source.trip = nextTrip;
            }).catch((reason) => {
              console.error("error fetching ", source);
              source.expires = new Date().getTime() + (1000 * 300); // do not try for 5 mins
            });
          });
        }, dwell);
      } else if (!isActive && slide !== 0) {
        clearInterval(interval);
      }
      return () => clearInterval(interval);
    },
    [isActive, slide, dwell, sources]
  );
  const onFullScreen = () => {
    console.log("onFullScreen");
    let elem = document.documentElement;

    if (elem) {
      elem.requestFullscreen().catch(err => {
        alert(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }
  }
  
  // Update the progress meter
  useEffect(
    () => {
      let interval: NodeJS.Timer | undefined;
      if (isActive) {
        interval = setInterval(() => {
          setProgress(progress => progress + 100);
        }, 100);
      } else if (!isActive && slide !== 0) {
        setProgress(0);
        clearInterval(interval);
      }
      return () => clearInterval(interval);
    },
    [isActive, slide, dwell]
  );

  const futureTrips = sources.filter((source, index) => {
    if (source.trip?.startTime) {
      let offset = new Date(source.trip.startTime).getTime() - new Date().getTime();
      if (offset > 0) {
        return offset < 1000 * 60 * 60 * 8; // less than 8 hours from now
      }
    }
    return false;
  });
  
  if ((futureTrips?.length ?? 0) === 0) {
    return <div className="canvas">
        <div className="app d-flex flex-column justify-content-around">
          <h3 className="text-center">SCHEDULE LOADING...</h3>
          <div className="row">
            <div className="col-6">
              <img src={logoOCBH} className="img-fluid" alt="OC Bay Hopper" />
            </div>
            <div className="col-6">
              <img src={logoSA} className="img-fluid" alt="Sail Alyosha" />
            </div>
          </div>
          Loading {sources.length} sources
        </div>
      </div>;
  }
  // const futureTrip = (index: number) => futureTrips[index];
  const progressPct = () => progress / dwell * 100;
  return <div className="canvas">
      {futureTrips[slide % futureTrips.length] && <Trip source={futureTrips[slide % futureTrips.length]} />}
      <div id="progress" className="progress" onClick={() => onFullScreen()}>
        <div className="progress-bar bg-secondary" role="progress" style={{ width: `${progressPct()}%` }} aria-valuenow={progressPct()} aria-valuemin={0} aria-valuemax={100} />
      </div>
    </div>;
}

export default App;
